/**
 * The language a call is held in (RFC 0307).
 *
 * Left to detect it per utterance, transcription guessed: a short English
 * phrase came back as Chinese, and the voice answered what it guessed. The
 * call is pinned to the person's language instead, from the window's locale
 * (`en-GB` is `en`), which is what both providers take.
 */

export function callLanguage(
  locale: string | undefined = typeof navigator === 'undefined'
    ? undefined
    : navigator.language,
): string {
  const code = (locale ?? '').split(/[-_]/)[0]?.toLowerCase() ?? ''
  return /^[a-z]{2}$/.test(code) ? code : 'en'
}
